import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const PlansBottomBannerWrapper = styled.div`

    border-width: 1px;
    text-align: center;
    font-size: 12px;
    z-index: 0;
    width: 100%;
`;

export const AddonsContainer = styled.div`
  display: flex;
  padding: 10px 12px;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 16px;
  background: var(--Surface-Light-grey50, #F5F5F5);
  margin-top: 12px;
`;

export const UpNextLabel = styled.b`
  color: var(--Purple-P500, #451999);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
`;